import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const addTopicQuestion = createAsyncThunk('addTopicQuestion', async (data) => {
    try {
        const values = data?.values ?? {};
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'topic_question',
            data: {
                "topic_id": values.topicId,
                "question_ids": (values.questions ?? []).map((q) => ({
                    question_id: q.question_id,
                    display_order: q.display_order,
                    marks: q.marks,
                    negative_marks: q.negative_marks,
                }))
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})
